import { RouteRecordRaw } from "vue-router";
import { RouteName } from "@/shared/constants/route-name";
import { DefaultLayout } from "@/layouts";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/announcements",
    name: RouteName.ANNOUNCEMENTS,
    component: () =>
      import(
        /* webpackChunkName: "announcement-page" */ "../views/organization-announcement.vue"
      ),
    meta: {
      requiresAuth: true,
      layout: DefaultLayout
    }
  }
];

export default routes;
